import { ChevronIconStyled, StyledOptionButton, TextBlock, TextContainer, TextOpacity } from './styles';
import { IOptionCardButtonProps } from './types';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { BodySmallBold } from 'v3/shared/typography/BodySmall';

export const OptionCardButton: React.FC<IOptionCardButtonProps> = ({ text, subtitle, onClick }) => {
  return (
    <StyledOptionButton onClick={onClick}>
      <TextContainer>
        <TextBlock>
        <BodySmallBold>{text}</BodySmallBold>
          {subtitle && (
            <TextOpacity>
              <BodySmallRegular>{subtitle}</BodySmallRegular>
            </TextOpacity>
          )}
        </TextBlock>
        <ChevronIconStyled />
      </TextContainer>
    </StyledOptionButton>
  );
};
